import { Navigate, Route, Routes } from 'react-router-dom';

import AutomationTripReport from './pages/ScheduleAutomationReport';
import LegacyReports from '@/pages/Reports';
import reportTypes from '@/pages/Reports/DynamicReport/reportTypes';

const DEFAULT_REPORT = Object.keys(reportTypes).at(0);

const Reports = () => {
  return (
    <Routes>
      <Route index path="/schedule-automation" element={<AutomationTripReport />} />
      <Route path="/:type/:id?" element={<LegacyReports />} />
      <Route path="*" element={<Navigate to={`/reports/${DEFAULT_REPORT}`} replace />} />
    </Routes>
  );
};

export default Reports;
